import { useMemo } from 'react';

import { CornerstoneRenderData } from '@InsightViewer/types';

export interface ViewportInfoLabelProps {
  cornerstoneRenderData: CornerstoneRenderData | null;
  width?: number;
}

const height = 17;
const y = 13;

export function ViewportInfoLabel({
  cornerstoneRenderData,
  width = 400,
}: ViewportInfoLabelProps): JSX.Element {
  const children = useMemo(() => {
    if (!cornerstoneRenderData) return null;

    return (
      <>
        <tspan fill="#8694B1">ZOOM</tspan>
        &nbsp; &nbsp;
        <tspan fill="#ffffff" data-testid="zoomAmount">
          {cornerstoneRenderData.viewport.scale?.toFixed(3)}
        </tspan>
        &nbsp; &nbsp; &nbsp;
        <tspan fill="#8694B1">WW / WL</tspan>
        &nbsp; &nbsp;
        <tspan fill="#ffffff">
          {cornerstoneRenderData.viewport.voi?.windowWidth} /{' '}
          {cornerstoneRenderData.viewport.voi?.windowCenter}
        </tspan>
        &nbsp;
      </>
    );
  }, [cornerstoneRenderData]);

  return (
    <svg
      width={width}
      height={height}
      style={{
        pointerEvents: 'none',
        userSelect: 'none',
        fontSize: 12,
      }}
    >
      <text
        textAnchor="end"
        x={width}
        y={y}
        width={width}
        height={height}
        stroke="#000000"
        strokeWidth={6}
        strokeLinejoin="round"
        strokeLinecap="round"
      >
        {children}
      </text>
      <text textAnchor="end" x={width} y={y} width={width} height={height}>
        {children}
      </text>
    </svg>
  );
}
